import { Link } from "react-router-dom";
import { ASSETS, FOOTER_LINKS, TRADE_LINKS, X_URL } from "@/data/content";
import { XMark } from "@/components/layout/Navbar";

const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-ice/10 bg-abyss">
    <div className="glow-line absolute inset-x-0 top-0" />
    <div className="mx-auto max-w-[1600px] px-5 py-14 md:px-8 md:py-20">
      <div className="grid gap-12 md:grid-cols-[1.3fr_1fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-4">
            <img
              src={ASSETS.logo}
              alt="ARCIMUS logo"
              className="h-12 w-12 rounded-full object-cover ring-1 ring-ice/30"
            />
            <div>
              <p className="font-display text-xl font-bold tracking-[0.28em] text-chrome">ARCIMUS</p>
              <p className="mt-1 font-term text-[10px] tracking-[0.32em] text-electric">
                THE FIRST PRIME OF ARC
              </p>
            </div>
          </div>
          <p className="mt-6 font-display text-xs tracking-[0.4em] text-silver">
            RISE. PROTECT. TRANSACT.
          </p>
          <a
            href={X_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-x-link"
            className="mt-8 inline-flex items-center gap-3 border border-ice/20 px-4 py-3 font-term text-[11px] tracking-[0.26em] text-silver transition-colors duration-300 hover:border-electric hover:text-ice"
          >
            <XMark className="h-4 w-4" /> X / @ARCIMUS
          </a>
        </div>

        <nav aria-label="Footer">
          <p className="hud-label mb-5">NAVIGATION</p>
          <ul className="grid grid-cols-2 gap-x-6 gap-y-3">
            {FOOTER_LINKS.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  data-testid={`footer-link-${link.label.toLowerCase()}`}
                  className="font-term text-[11px] tracking-[0.22em] text-silver transition-colors duration-300 hover:text-ice"
                >
                  {link.label.toUpperCase()}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <p className="hud-label mb-5">TOKEN</p>
          <div className="space-y-4">
            <div className="border-b border-ice/10 pb-3">
              <p className="hud-label">CONTRACT ADDRESS</p>
              <p className="mt-2 font-term text-[11px] tracking-[0.24em] text-epurple" data-testid="footer-ca">
                CA: {TRADE_LINKS.ca}
              </p>
            </div>
            <a
              href={TRADE_LINKS.buy}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-buy-link"
              className="block font-term text-[11px] tracking-[0.24em] text-silver transition-colors duration-300 hover:text-ice"
            >
              BUY ↗ ARGUS.WORLD
            </a>
            <a
              href={TRADE_LINKS.chart}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-chart-link"
              className="block font-term text-[11px] tracking-[0.24em] text-silver transition-colors duration-300 hover:text-ice"
            >
              CHART ↗ DEXSCREENER
            </a>
          </div>
        </div>

        <div>
          <p className="hud-label mb-5">SYSTEM</p>
          <dl className="space-y-4">
            <div className="flex items-center justify-between border-b border-ice/10 pb-3">
              <dt className="hud-label">ARCIMUS SYSTEM</dt>
              <dd className="hud-value flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-electric shadow-[0_0_8px_rgba(0,168,255,0.9)]" />
                ONLINE
              </dd>
            </div>
            <div className="flex items-center justify-between border-b border-ice/10 pb-3">
              <dt className="hud-label">NETWORK</dt>
              <dd className="hud-value">ARC</dd>
            </div>
            <div className="flex items-center justify-between border-b border-ice/10 pb-3">
              <dt className="hud-label">PROJECT STATUS</dt>
              <dd className="hud-value">ACTIVE</dd>
            </div>
          </dl>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-ice/10 pt-6 sm:flex-row sm:items-center">
        <p className="font-term text-[11px] tracking-[0.24em] text-silver">© 2026 ARCIMUS</p>
        <p className="font-term text-[10px] tracking-[0.24em] text-silver/60">
          CONCEPTUAL INTERFACE — SIMULATED DATA WHERE LABELLED
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
